import { TagIcon } from '@components';
import { hnaviSearchPath } from '@paths';
import { addTrailingSlash } from '@utils';
import { Tag as BaseTag } from '@/src/generated/graphql';

type Tag = Pick<BaseTag, 'name' | 'slug' | 'useSlugForHnaviSearch'>;

const notEmptyTag = (
  tag: Tag
): tag is {
  name: string;
  slug: string;
  useSlugForHnaviSearch: string | null | undefined;
} => !!tag.name && !!tag.slug;

export const Tags: React.FC<{
  tags: Tag[];
}> = ({ tags }) => (
  <div className='flex flex-wrap gap-2'>
    {tags.filter(notEmptyTag).map((tag) => (
      <a
        href={addTrailingSlash(
          hnaviSearchPath(
            tag.useSlugForHnaviSearch === 'true'
              ? tag.slug
              : encodeURIComponent(tag.name)
          )
        )}
        key={tag.slug}
        className='flex items-center gap-2 rounded-lg bg-lightgray px-4 py-2'
      >
        <TagIcon className='h-4 text-secondary2' />
        {tag.name}
      </a>
    ))}
  </div>
);
